import { render, staticRenderFns } from "./modalConfirmRemoveAssistance.vue?vue&type=template&id=56a5ae82&scoped=true&"
import script from "./modalConfirmRemoveAssistance.vue?vue&type=script&lang=js&"
export * from "./modalConfirmRemoveAssistance.vue?vue&type=script&lang=js&"
import style0 from "./modalConfirmRemoveAssistance.vue?vue&type=style&index=0&id=56a5ae82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5ae82",
  null
  
)

export default component.exports